import { ExchangeRatesChartDailyData } from 'models/market'
import { ChartistPayload } from 'models/chartist'
import * as Chartist from 'chartist'
import chartTooltipPlugin from './chart-tooltip-plugin'
import marketService from 'services/market'

const currencyPairs = Array.from(document.querySelectorAll('[data-currency-id]')).map((el) =>
  el.getAttribute('data-currency-id'),
)
const charts = {}

function updateFromMarketBrief(
  pair: string,
  marketHistoryDaily: ExchangeRatesChartDailyData,
): ExchangeRatesChartDailyData {
  const marketBrief = marketService.getMarketBrief().filter((el) => el.pair === pair)[0]

  if (!marketBrief) {
    return marketHistoryDaily
  }

  const timestamp = Math.trunc(new Date(marketBrief.ts).getTime() / 1000)
  return [...marketHistoryDaily, [timestamp, marketBrief.directExchangeOffers.forexNow]]
}

function prepareData(data: ExchangeRatesChartDailyData): ChartistPayload {
  const chartData: ChartistPayload = {
    series: [[]],
    labels: [],
  }

  chartData.labels = data.map((record) => record[0])
  chartData.series = [data.map((record) => record[1])]

  return chartData
}

function createChart(data: ExchangeRatesChartDailyData, pair: string): void {
  const options: Chartist.ILineChartOptions = {
    chartPadding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
    lineSmooth: false,
    axisX: {
      showGrid: false,
      showLabel: false,
      offset: 0,
    },
    axisY: {
      showGrid: false,
      showLabel: false,
      offset: 0,
    },
    fullWidth: true,
    plugins: [chartTooltipPlugin()],
  }

  const chart = new Chartist.Line(`[data-rates-chart="${pair}"]`, prepareData(data), options)
  charts[pair] = chart
}

const buildParam = (): string => currencyPairs.join('&pairs[]=')

const hideSpinner = (pair: string): void => {
  const $offlineBoxElement = document.querySelector<HTMLDivElement>(`[data-offline-box="${pair}"]`)
  if ($offlineBoxElement) {
    $offlineBoxElement.hidden = true
  }
}

const initSingleChart = (marketHistoryDaily: ExchangeRatesChartDailyData): void => {
  for (const [pair] of Object.entries(marketHistoryDaily)) {
    const updatedData = updateFromMarketBrief(pair, marketHistoryDaily[pair])
    createChart(updatedData, pair)
    hideSpinner(pair)
    window.addEventListener('marketBrief fetched', () => {
      const chart = charts[pair]
      if (chart) {
        const updatedData = prepareData(updateFromMarketBrief(pair, marketHistoryDaily[pair]))
        chart.update(updatedData)
      }
    })
  }
}

export function initCharts() {
  marketService.fetchMarketHistoryDaily(buildParam()).then((marketHistoryDaily) => initSingleChart(marketHistoryDaily))
}
